import { createSelector } from 'reselect';
import _get from 'lodash/get';
import getActivePaln from '../helpers/billing/getActivePlan';
import getTotalFeaturesAmount from '../../components/Billing/Overview/helpers/getTotalFeaturesAmount';

const userSelector = (state) => state.user;

const billingPlansSelector = (state) => _get(state, 'billing.data.plans', []);

const subscriptionItemsSelector = (state) => _get(state, 'user.customer.subscription.items.data', []);

export const getSelectedPlan = (state) => state.billing.data.plans.find((plan) => plan.selectedPlan);

const selectAddonsFeatures = createSelector(userSelector, (user) => user.addonsFeatures || {});

export const getActivePlansSelector = createSelector(subscriptionItemsSelector, billingPlansSelector, getActivePaln);

export const getUser = createSelector(userSelector, (user) => {
  const {
    trialEnds,
    email,
    picsioStorage,
    subscriptionFeatures: {
      teammatesCount = 0,
      teammatesCountIncludingPending = 0,
      websitesCount = 0,
      teammatesLimit = 0,
      websitesLimit = 0,
      totalSize = 0,
    },
    customer: {
      balance, discount, card = {}, subscription = {},
    },
    team,
  } = user;
  const { coupon } = discount || {};
  const {
    current_period_end: currentPeriodEnd,
    cancel_at_period_end: cancelPeriodEnd,
  } = subscription;

  return {
    trialEnds,
    email,
    picsioStorage,
    card,
    coupon,
    // uncomment for coupon testing
    // coupon: {
    //   id: 'PICSIO_STORAGE_50POFF_ONEYEAR', object: 'coupon', amount_off: null, created: 1615891753, currency: null, duration: 'repeating', duration_in_months: 12, livemode: false, max_redemptions: null, metadata: {}, name: 'PICSIO_STORAGE_50POFF_ONEYEAR', percent_off: 50, redeem_by: null, times_redeemed: 10, valid: true,
    // },
    teammatesCount,
    teammatesCountIncludingPending,
    websitesCount,
    teammatesLimit,
    websitesLimit,
    balance,
    totalSize,
    subscription: {
      currentPeriodEnd,
      cancelPeriodEnd,
    },
    team,
  };
});

export const selectTotalAddons = createSelector(
  selectAddonsFeatures,
  getSelectedPlan,
  (addonsFeatures, selectedPlan) => {
    const planToUpdate = _get(selectedPlan, 'planToUpdate', {});

    const { addons } = getTotalFeaturesAmount(
      planToUpdate.addons || [],
      planToUpdate.metadata || {},
      addonsFeatures,
    );

    return { addons };
  },
);

export default {
  getActivePlansSelector,
  getUser,
};
